// extracted by mini-css-extract-plugin
export default {"tr":"KxRgrDetails_tr__HB6Of","tdLeft":"KxRgrDetails_tdLeft__a+CKl"};